module.exports = __webpack_public_path__ + "img/xinlang.57f3edb4.png";